import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import s from "./Spin.module.scss";

const Spin = ({ type, hover }) => {
  return (
    <div
      className={[s.spinning, type === "search" ? s.searching : ""].join(" ")}
      {...(hover && { style: { zIndex: "1000" } })}
    >
      <CircularProgress
        sx={{
          color: "#36b3be",
        }}
      />
    </div>
  );
};

export default Spin;
